<template>
    <div class="list d-flex h-100 flex-column align-items-center px-3">
        <div v-if="!getSlimFilters || getIsLoadingEvents" class="text-center p-4">
            <loader></loader>
        </div>

        <div v-else class="d-flex flex-column w-100 h-100 pt-4">

            <!-- Products filter -->
            <div class="w-100 flex-grow-1 overflow-auto">
                <product-filter :products="getProductsShowingOnCalendar" @change="updateFilters()" @loaded="updateFilters()" />
            </div>

            <div class="mb-4 border-top-light mt-2">
                <div class="w-100">
                    <label>Resource:</label>
                    <!-- <v-select label="name" placeholder="All Resources" @input="updateFilters" v-model="selectedResource" :options="resources"></v-select> -->

                    <multiselect
                        v-model="selectedResource"
                        :searchable="true"
                        :options="resources"
                        :multiple="true"
                        :taggable="false"
                        track-by="id"
                        label="name"
                        selectLabel=""
                        deselectLabel=""
                        class=""
                        placeholder="All Resources"
                        open-direction="top"
                        @input="updateFilters"
                        @remove="updateFilters"
                    >
                    </multiselect>

                </div>

                <div class="w-100 d-flex mt-2">
                    <button class="btn tertiary wide reset" @click="renderFilters(getStoredEvents, true)">Clear All</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'
    import Multiselect from 'vue-multiselect'
    import ProductFilter from './filters/productFilterV2'

    export default {
        props: {
            defaultView: String,
        },
        data: function() {
            return {
                currentView: this.defaultView,
                isVisible: false,
                selectedProduct: [],
                selectedTransport: null,
                selectedResource: null,
                selectedCategory: null,
                checkboxes: {
                    transport: 'Hide transport',
                    product: 'Hide product name',
                    availability: 'Hide availability',
                },
            }
        },
        watch:{
            getStoredEvents: function(newVal, oldVal){
                //reset filters on change
                // this.renderFilters(newVal, false)
                this.updateFilters()
            }
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getCurrentView',
                'getFilters',
                'getStoredEvents',
                'getSlimFilters',
                'getIsLoadingEvents',
                'getfilterBlacklistProducts',
                'getProductsShowingOnCalendar',
                // 'getStoredEvents',
            ]),
            products: function() {
                if (this.getStoredEvents !== undefined) {
                    let products = [];

                    this.getStoredEvents.forEach(event => {
                        //check if product is already present on products
                        let filteredArr = products.filter(product => {
                            return product.id == event.product.id
                        })

                        if (filteredArr.length == 0 && event.product.name) {
                            products.push({
                                name: event.product.name,
                                id: event.product.id,
                                color: event.product.color
                            });
                        }
                    });
                    return products
                    // return ['All products'].concat(products);
                }
            },
            resources: function() {
                // return ['All resources'].concat(this.getSlimFilters.resourceList);
                return this.getSlimFilters.resourceList;
            },
            categories: function() {
                return ['All categories'].concat(this.getSlimFilters.categoryList);
            },
            filters: function() {
                return this.getFilters;
            }
        },
        methods: {
            ...mapActions([
                'updateSidebar',
                'updateCurrentView',
                'toggleCalendarFilter',
                'changeFilterSelectedProducts',
            ]),
            reloadEvents: function(view, date) {
                let d = moment(date);

                this.$emit('reloadEvents', {
                    start: this.formatDate(d.clone().startOf('month')),
                    end: this.formatDate(d.clone().endOf('month'))
                });
            },
            showFilters: function(e) {
                this.isVisible = true;
            },
            hideFilters: function(e) {
                this.isVisible = false;
            },
            updateFilters(e) {
                var filtered = this.getStoredEvents;

                // Narrow events list from each of the filters

                // Filter by Product
                if (this.getfilterBlacklistProducts && this.getfilterBlacklistProducts != null && this.getfilterBlacklistProducts.length != 0) {
                    //
                    // filtered = filtered.filter(event => {
                    //     let isFound = false
                    //
                    //     for (let selectedProductItem of this.getfilterBlacklistProducts) {
                    //         if (selectedProductItem.id == event.product.id) {
                    //             isFound = true
                    //         }
                    //     }
                    //
                    //     return isFound
                    // });

                    filtered = filtered.filter(event => {
                        return this.getfilterBlacklistProducts.find(blackListProduct => blackListProduct.id == event.product.id ) == undefined
                    })



                } else if(this.getfilterBlacklistProducts.length == 0){
                    filtered = this.getStoredEvents
                }



                // Filter by Resource
                if (this.selectedResource && this.selectedResource != null && this.selectedResource.length != 0) {

                    filtered = filtered.filter(event => {
                        let isFound = false

                        for (let selectedResourceItem of this.selectedResource) {


                            for (let selectedEventResource of event.eventResources) {

                                if (selectedResourceItem.id == selectedEventResource.id) {
                                    isFound = true
                                    // break
                                }
                            }

                        }

                        return isFound
                    });
                }

                if (this.selectedCategory) {
                    if (this.selectedCategory == "All categories") {
                        this.selectedCategory = null;
                        return false
                    }

                    filtered = filtered.filter(i => i.product.category.id === this.selectedCategory.id);

                }

                this.renderFilters(filtered, false);
            },

            // Remove and re-fetch source for events.
            // If 'reset' is set to true, all filters are cleared

            renderFilters: function(source, reset) {
                let cal = $('#calendar');

                cal.fullCalendar('removeEvents');
                cal.fullCalendar('addEventSource', source);

                if (reset) {
                    // this.selectedProduct = null;
                    // this.changeFilterSelectedProducts(this.products)
                    this.changeFilterSelectedProducts(JSON.parse(JSON.stringify(this.products)))
                    this.selectedTransport = null;
                    this.selectedResource = null;
                    this.selectedCategory = null;
                }
                this.$forceUpdate()
            },
            toggleStatus: function(e, filter) {
                let value = !this.filters[filter];

                this.toggleCalendarFilter({ filter: filter, value: value });

                $('#calendar').fullCalendar('rerenderEvents');
            },
        },
        components: {
            vSelect: extendedVSelect,
            Loader,
            Multiselect,
            ProductFilter
        }
    }
</script>

<style lang="scss" scoped="">
    @import '../../assets/scss/_variables.scss';

    .filters {
        height: 7vh;
        border-bottom: 1px solid $light;

        .v-select.searchable {
            input[type=search] {
                font-size: $font-size-small;
                line-height: 1.4rem;
                height: 1.4rem;
                padding: 0 2rem 0 0.75rem;
            }

            .dropdown-toggle {
                height: 34px;
            }

            .open-indicator {
                bottom: 0;
            }
        }

        .type-filters {
            .dropdown {
                margin-right: 1rem;
            }
        }

        // .period-filters {
        //     flex: 0;
        //     position: relative;
        //
        //     .box {
        //         position: absolute;
        //         top: 0;
        //         right: 0;
        //         z-index: 5;
        //         width: 15rem;
        //
        //         .view-options {
        //             border-radius: 16px;
        //             border: 1px solid $medium;
        //
        //             > li {
        //                 display: inline-block;
        //                 padding: 0.3rem 1rem;
        //                 border-radius: inherit;
        //
        //                 &.active {
        //                     color: $lightest;
        //                     background-color: $brand;
        //                     cursor: default;
        //                     border: solid rgba(74, 82, 106, 0.36);
        //                     border-width: 0 1px;
        //                 }
        //             }
        //         }
        //     }
        // }
    }
</style>



// WEBPACK FOOTER //
// Filters.vue?1950553c